import { Component, Input } from '@angular/core';
import { ProjectionStatus } from '../store-add/projection-status.enum';
import { roundToThousand } from 'src/app/core/util/math-utils';
@Component({
  standalone: false,
  selector: 'app-summary-details',
  templateUrl: './summary-details.component.html',
  styleUrls: ['./summary-details.component.scss'],
})
export class SummaryDetailsComponent {
  @Input() isInitialized: boolean = false;
  @Input() weeklySalesLowerRange: number;
  @Input() weeklySalesUpperRange: number;
  @Input() totalSalesProjectionStatus:any = ProjectionStatus.Average;
  @Input() sqftProjectionStatus:any = ProjectionStatus.Average;
  @Input() bannerCBSAAverages: any;
  @Input() cbsaName: string = '';
  @Input() nearestStore: any;
  @Input() densityClass: string;
  @Input() closetCompetitor: any;
  @Input() futureStoreCount: number = 0;
  @Input() nearestFutureStoreDistance: number = 0;
  @Input() nearestFutureStoreName: string = '--';
  @Input() isSubmitted: boolean = false;
  roundToThousand = roundToThousand;
  ProjectionStatus = ProjectionStatus; // Make enum available to template

  getStateAbbreviation(cbsaName: string): string {
    const parts = cbsaName?.split(',');
    return parts?.length > 1 ? parts[0].trim() : cbsaName;
  }

  getProjectionStatusClass(status: ProjectionStatus): string {
    switch (status) {
      case ProjectionStatus.BelowAverage:
        return 'text-warn';
      case ProjectionStatus.Average:
        return 'text-muted';
      case ProjectionStatus.AboveAverage:
        return 'text-seafoam';
      default:
        return 'text-muted';
    }
  }


}
